import type { Country } from "./country";
import type { Dsp } from "./dsp";
import type { ReleaseCandidateBase } from "./release-candidate";
import type { ReleaseEntry } from "./release-entry";
import type { ServiceIssue } from "./service-issue";

export enum ReleaseDistributionStatusEnum {
  TakenDown = -40,
  TakeDown = -30,
  RejectedbyDSP = -20,
  RejectedbyQA = -10,
  Draft = 0,
  Submitted = 10,
  InReview = 20,
  Released = 30,
}

export type ReleaseDistributionStatus = {
  color: string;
  id: number;
  name: string;
};

export type ReleaseBase = {
  coverImagePath: string | null;
  dsps: Array<Dsp>;
  excludedCountries: Array<Country>;
  originalReleaseDate: string | null;
  preferredReleaseDate: string | null;
  title: string;
  uid: string;
};

export type ReleaseInList = ReleaseBase & {
  distributionStatus: ReleaseDistributionStatus;
};

export type Release = ReleaseBase & {
  albumPriceCategoryId: number;
  artistUid: string;
  distributionStatus: ReleaseDistributionStatus;
  durationInSeconds?: number | null;
  ean: string | null;
  entries: Array<ReleaseEntry>;
  issues: Array<ServiceIssue>;
  subtitle: string | null;
  trackPriceCategoryId: number;
};

export function isReleaseEditable(
  release: Release | ReleaseCandidateBase | undefined,
) {
  if (!release) {
    return true;
  }

  if (!("distributionStatus" in release)) {
    return true;
  }

  return [
    ReleaseDistributionStatusEnum.Draft,
    ReleaseDistributionStatusEnum.RejectedbyQA,
  ].includes(release.distributionStatus.id);
}
